export default __webpack_public_path__ + "static/media/img_company_main_m.f68e69ac.png";